import React from 'react'
import style from  '../../Styles/Html/MessageAlert.module.css'


const MessageAlert = ({text, typeOfMessage}) => {
  return (
    <div className={`${typeOfMessage === 1 ? style.warning : style.error}`}>
         <h6>{text}</h6>
    </div>
  )
}

export default MessageAlert